import ReactDOM from 'react-dom';
import '../css/components/ModalInferior.css';

export function ModalInferior({children}) {
  function alturaHeader() {
    const valorArbitrario = 4;
    const idMainHeader = window.document.getElementById('idMainHeader');
    const alturaHeader = idMainHeader? idMainHeader.offsetHeight + valorArbitrario:valorArbitrario;
    return window.top.innerHeight - alturaHeader;
  }
  
  function clickContainer(e) {
    if (e.target.id === 'modalContainerInferior') children.props.mostrarModal();
  }

  const altura = obtenerAltura();

  function obtenerAltura() {
    return window.self !== window.top ? {height: alturaHeader()} : {height: '100vh'};
  }

  return (
    <div
      id='modalContainerInferior'
      className='fixed inset-0 z-4 bg-sphericaDarkBlue bg-opacity-75 backdrop-filter overflow-x-hidden overflow-y-auto'
      onClick={clickContainer}
    >
      <div id='modalContentInferior' className='flex justify-center modal-inferior' style={altura}>
        <div
          className='flex flex-col bg-white md:rounded-16 rounded-tl-16 rounded-tr-16 border border-modal shadow-modal pt-2 px-2.5 md:pb-3 pb-5 md:m-auto'
          style={{width: 'fit-content', height: 'fit-content'}}
        >
          {children}
        </div>
      </div>
    </div>
  );
}

export default function ModalPortal({children}) {
  return ReactDOM.createPortal(<ModalInferior>{children}</ModalInferior>, document.getElementById('modal-root'));
}
